import { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { EditListingForm } from './components/EditListingForm';
import { fetchListing, type Listing } from '../../features/marketplace/api';
import { Button } from '../../components/ui/Button';

export function MarketplaceEditPage() {
  const { listingId } = useParams<{ listingId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [listing, setListing] = useState<Listing | null>(location.state?.listing || null);
  const [loading, setLoading] = useState(!location.state?.listing);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!listing && listingId) {
      loadListing();
    }
  }, [listingId]);

  async function loadListing() {
    if (!listingId) return;

    try {
      setLoading(true);
      const data = await fetchListing(listingId);
      setListing(data);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load listing');
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-white dark:bg-slate-900">
        <div className="text-center text-slate-600 dark:text-slate-400 py-12">Loading listing...</div>
      </div>
    );
  }

  if (error || !listing) {
    return (
      <div className="min-h-screen bg-white dark:bg-slate-900">
        <div className="max-w-2xl mx-auto px-4 py-12">
          <Button onClick={() => navigate('/marketplace/seller')} variant="secondary" className="mb-4">
            ← Back to Seller Dashboard
          </Button>
          <div className="bg-red-100 dark:bg-red-900/20 border border-red-300 dark:border-red-900 rounded-lg p-6 text-red-700 dark:text-red-400">
            <h2 className="text-lg font-semibold mb-2">Error Loading Listing</h2>
            <p>{error || 'Listing not found'}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <EditListingForm listing={listing} />
      </div>
    </div>
  );
}
